import { createSlice } from "@reduxjs/toolkit";
import {toast, ToastContainer } from "react-toastify";

export const resetPasswordSlice = createSlice({
	name: "reset_password",
	initialState: {
		resetPassMessage: "",
		errors: [],
	},

	reducers: {
		getResetPassMessage: (state, action) => {
			state.resetPassMessage = action.payload
		},
		getResetPassMessageSuccess: (state, action) => {
			state.resetPassMessage = action.payload
		},
		// forget the previous reset so the page doesn't redirect to login on arrival
		clearResetPassState: (state) => {
			state.resetPassMessage = ""
			state.errors = []
		},
		getErrors: (state, action) => {
			state.errors = action.payload
			// console.log(state.errors, 'error form reducer')
			if(state.errors.non_field_errors){
				toast.error(`${state.errors.non_field_errors}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}else if(state.errors.password1) {
				toast.error(`${state.errors.password1}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
		},
	},
})

// Action creators are generated for each case reducer function
export const {getResetPassMessage, getResetPassMessageSuccess, getErrors, clearResetPassState} = resetPasswordSlice.actions

export default resetPasswordSlice.reducer
